import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import LoginHeader from "./LoginHeader";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: "50px", // space for fixed footer
  },
}));

function LoginPage(props) {
  useEffect(() => {}, []);

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LoginHeader />
    </div>
  );
}

export default LoginPage;
